import React from 'react';
import {StyledTextInput} from './styles';

const TextInput = ({onChange, ...props}) => {
  return <StyledTextInput onChange={onChange} {...props} />;
};

export default TextInput;
